// src/services/leavesService.js
import { apiRequest } from './api';

export const leavesService = {
    // Get leave requests with filters
    getLeaveRequests: async (params = {}) => {
        try {
            const response = await apiRequest.get('/leaves', { params });
            return response.data.data;
        } catch (error) {
            throw new Error(error.message || 'Failed to fetch leave requests');
        }
    },

    // Apply for leave
    applyLeave: async (leaveData) => {
        try {
            const response = await apiRequest.post('/leaves/apply', leaveData);
            return response.data.data;
        } catch (error) {
            throw new Error(error.message || 'Failed to apply for leave');
        }
    },

    // Approve or reject leave
    approveLeave: async (leaveId, status, comments = '') => {
        try {
            const normalizedStatus = String(status || '').toLowerCase();
            const endpoint = normalizedStatus === 'rejected' ? '/leaves/reject' : '/leaves/approve';

            const response = await apiRequest.post(endpoint, {
                leave_request_id: leaveId,
                status: normalizedStatus,
                approver_comments: comments
            });
            return response.data.data;
        } catch (error) {
            throw new Error(error.message || 'Failed to process leave request');
        }
    },

    // Get leave types
    getLeaveTypes: async (premisesId = null) => {
        try {
            const params = {};
            if (premisesId) params.premises_id = premisesId;

            const response = await apiRequest.get('/leaves/types', { params });
            return response.data.data;
        } catch (error) {
            throw new Error(error.message || 'Failed to fetch leave types');
        }
    },

    // Create leave type (admin only)
    createLeaveType: async (leaveTypeData) => {
        try {
            const response = await apiRequest.post('/leaves/types', leaveTypeData);
            return response.data.data;
        } catch (error) {
            throw new Error(error.message || 'Failed to create leave type');
        }
    },

    // Update leave type
    updateLeaveType: async (leaveTypeId, leaveTypeData) => {
        try {
            console.log('Calling API to update leave type:', leaveTypeId, leaveTypeData);
            const response = await apiRequest.put(`/leaves/types/${leaveTypeId}`, leaveTypeData);
            return response.data.data;
        } catch (error) {
            console.error('API Error updating leave type:', error.response?.data || error);
            throw new Error(error.response?.data?.message || error.message || 'Failed to update leave type');
        }
    },

    // Delete leave type
    deleteLeaveType: async (leaveTypeId) => {
        try {
            const response = await apiRequest.delete(`/leaves/types/${leaveTypeId}`);
            return response.data.data;
        } catch (error) {
            throw new Error(error.message || 'Failed to delete leave type');
        }
    },

    // Get leave balance for a staff member
    getLeaveBalance: async (staffId, year = new Date().getFullYear()) => {
        try {
            const response = await apiRequest.get(`/leaves/balance/${staffId}`, {
                params: { year }
            });
            return response.data.data;
        } catch (error) {
            throw new Error(error.message || 'Failed to fetch leave balance');
        }
    },

    // Get leave statistics
    getLeaveStats: async (filters = {}) => {
        try {
            const response = await apiRequest.get('/leaves/stats', { params: filters });
            return response.data.data;
        } catch (error) {
            throw new Error(error.message || 'Failed to fetch leave statistics');
        }
    },

    // Cancel leave request
    cancelLeave: async (leaveId) => {
        try {
            const response = await apiRequest.post(`/leaves/${leaveId}/cancel`);
            return response.data.data;
        } catch (error) {
            throw new Error(error.message || 'Failed to cancel leave request');
        }
    }
};
